import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "justify-start items-start" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "q-ml-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_counterparty_info_component = _resolveComponent("counterparty-info-component")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.el.Id > 0 && !_ctx.hideInfoBtn)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_app_icon, {
            class: "cparty-row__info q-mx-xs",
            name: "info-circle-outline",
            width: "18px",
            color: "#979797",
            "hover-color": "#499259",
            cursor: "pointer",
            title: _ctx.$t('information'),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showCPartyInfoMode = true))
          }, null, 8, ["title"]),
          _createVNode(_component_q_dialog, {
            modelValue: _ctx.showCPartyInfoMode,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showCPartyInfoMode) = $event)),
            "no-shake": "",
            "full-width": true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_counterparty_info_component, {
                "counterparty-id": _ctx.el.Id,
                onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showCPartyInfoMode = false))
              }, null, 8, ["counterparty-id"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      style: {"display":"inline"},
      class: _normalizeClass(_ctx.el.AttachedToClient ? 'text-grey-6' : ''),
      innerHTML: _ctx.displayHtml
    }, null, 10, _hoisted_2),
    (!_ctx.hideRemoveBtn)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: "cparty-row__remove",
          title: _ctx.$t('remove')
        }, [
          _createVNode(_component_app_icon, {
            name: "close",
            width: "16px",
            color: "#979797",
            "hover-color": "#616161",
            cursor: "pointer"
          }),
          _createVNode(_component_q_menu, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_card_section, { class: "row items-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_avatar, {
                        icon: "delete",
                        size: "md",
                        color: "grey",
                        "text-color": "white"
                      }),
                      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("sure_delete")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card_actions, {
                    onKeydown: _ctx.windowKeyDown,
                    align: "right"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_q_btn, {
                        size: "sm",
                        flat: "",
                        label: _ctx.$t('cancel'),
                        color: "dark",
                        ref: 'cancelbtn'
                      }, null, 8, ["label"]), [
                        [_directive_close_popup]
                      ]),
                      _withDirectives(_createVNode(_component_q_btn, {
                        size: "sm",
                        flat: "",
                        label: _ctx.$t('remove'),
                        autofocus: "",
                        color: "dark",
                        ref: 'okbtn',
                        onClick: _ctx.detach
                      }, null, 8, ["label", "onClick"]), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _: 1
                  }, 8, ["onKeydown"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ], 8, _hoisted_3))
      : _createCommentVNode("", true)
  ]))
}